/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GenericTableResponse } from '../../models/generic-table-response';

export interface GetLongActiveTours$Params {

/**
 * a parameter to filter out tours on the duration (time passed from start till now). E.g. 12 hours
 */
  duration: number;
}

export function getLongActiveTours(http: HttpClient, rootUrl: string, params: GetLongActiveTours$Params, context?: HttpContext): Observable<StrictHttpResponse<GenericTableResponse>> {
  const rb = new RequestBuilder(rootUrl, getLongActiveTours.PATH, 'get');
  if (params) {
    rb.query('duration', params.duration, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GenericTableResponse>;
    })
  );
}

getLongActiveTours.PATH = '/api/v1/statistics-dashboard/active_tours';
